import { jsx as s, jsxs as u } from "../../_virtual/jsx-runtime.mjs";
import * as e from "react";
import { content as R, popup as E, iconWrap as H, closeIcon as B, reoPopupRoot as W, popupWrap as z, popupScrollBar as j, title as D, body as L, footer as O } from "./css/ReoPopup.mjs";
import q from "../ReoIcon/ReoIcon.mjs";
import G from "../../Basic/ScrollbarContainer/ScrollContainer.mjs";
import { createPortal as K } from "react-dom";
import { defaultReoPopupProps as t } from "./const.mjs";
import { suffixPx as C } from "../../utils/suffixPx.mjs";
import { getValByDef as n } from "../../utils/getValByDef.mjs";
import { withPx as Q } from "../../utils/withPx.mjs";
import { getGlobal as r } from "../../utils/getGlobal.mjs";
import { CreateNotScrollStyle as U } from "../../utils/createNotScrollStyle.mjs";
import a from "../../depend/classnames/index.mjs";
import V from "./ReoPopupContext.mjs";
import { useTheme as X } from "../../hook/useTheme.mjs";
import { EThemeTemplate as A } from "../../common/type.mjs";
const F = { includeByPopup: !0 }, J = (o) => {
  const y = X({ theme: o.theme, template: A.POPUP }), i = e.useMemo(
    () => n(o.popupType, t.popupType),
    [o.popupType]
  ), v = e.useMemo(() => ({
    width: o.width ? C(o.width) : "unset",
    ...o.style
  }), [o.style, o.width]), p = e.useRef(null), d = e.useRef(!0);
  e.useEffect(() => {
    var l;
    o.open && ((l = p.current) == null || l.focus());
  }, [o.open]), e.useLayoutEffect(() => {
    const l = new U();
    return o.open ? l.append() : l.remove(), () => {
      l.remove();
    };
  }, [o.open]);
  const N = e.useMemo(() => {
    var l;
    return o.open && (d.current = !1, (l = p.current) == null || l.focus()), o.open;
  }, [o.open]), c = e.useCallback(() => {
    var l;
    (l = o.onClose) == null || l.call(o);
  }, [o]), x = e.useCallback(() => {
    n(o.maskClosable, t) && c();
  }, [c, o.maskClosable]), b = e.useCallback((l) => {
    l.stopPropagation();
  }, []), g = e.useCallback((l) => {
    var m;
    l.key === "Escape" && n(o.escClose, t.escClose) && ((m = o.onClose) == null || m.call(o));
  }, [o]), M = e.useCallback((l, m) => d.current ? null : K(l, m), []), P = e.useMemo(
    () => n(C(o.childrenMaxHeight ?? ""), t.childrenMaxHeight),
    [o.childrenMaxHeight]
  ), k = e.useMemo(() => a(
    R[i],
    o.contentClassName
  ), [i, o.contentClassName]), w = e.useMemo(() => ({
    ...o.contentStyle
  }), [o.contentStyle]), I = e.useMemo(() => a(
    E[i],
    o.className
  ), [i, o.className]), f = e.useMemo(() => a(o.iconWrapClass, H), [o.iconWrapClass]), h = e.useMemo(() => a(o.iconClass, B), [o.iconClass]), S = e.useMemo(
    () => o.closeIconNode ?? /* @__PURE__ */ s(
      "div",
      {
        onClick: c,
        className: f,
        children: /* @__PURE__ */ s(
          q,
          {
            className: h,
            name: n(o.closeIcon, t.closeIcon),
            width: Q(n(o.iconSize, t.iconSize)),
            color: "var(--color)"
          }
        )
      }
    ),
    [c, h, f, o.closeIcon, o.closeIconNode, o.iconSize]
  ), T = e.useMemo(() => r().document ? typeof o.getContainer == "function" ? o.getContainer() : o.getContainer instanceof HTMLElement ? o.getContainer : typeof o.getContainer == "string" ? r().document.querySelector(o.getContainer) ?? r().document.body : r().document.body : null, [o]);
  return !r().document || !o.open && o.destroyOnClose ? null : M(
    /* @__PURE__ */ s(
      "div",
      {
        className: a(y, W),
        children: /* @__PURE__ */ u(
          "div",
          {
            className: z,
            tabIndex: -1,
            onClick: x,
            style: {
              display: N ? "block" : "none"
            },
            onKeyDown: g,
            children: [
              /* @__PURE__ */ s(
                "div",
                {
                  ref: p,
                  tabIndex: 0,
                  "aria-hidden": !0,
                  style: { width: "0px", height: " 0px", overflow: "hidden", outline: "none" }
                }
              ),
              /* @__PURE__ */ u(
                "div",
                {
                  role: "dialog",
                  onClick: b,
                  className: I,
                  "aria-modal": !0,
                  style: v,
                  children: [
                    S,
                    /* @__PURE__ */ s(
                      "div",
                      {
                        className: k,
                        style: w,
                        children: /* @__PURE__ */ u(
                          G,
                          {
                            maxHeight: P,
                            scrollBarClassName: j,
                            children: [
                              o.title ? /* @__PURE__ */ s(
                                "div",
                                {
                                  className: a(
                                    D,
                                    o.titleClassName
                                  ),
                                  children: o.title
                                }
                              ) : null,
                              /* @__PURE__ */ s(
                                "div",
                                {
                                  className: a(
                                    L,
                                    o.bodyClassName
                                  ),
                                  children: /* @__PURE__ */ s(V.Provider, { value: F, children: o.children })
                                }
                              ),
                              o.footer ? /* @__PURE__ */ s(
                                "div",
                                {
                                  className: a(
                                    O,
                                    o.footerClassName
                                  ),
                                  children: o.footer
                                }
                              ) : null
                            ]
                          }
                        )
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ s(
                "div",
                {
                  tabIndex: 0,
                  "aria-hidden": !0,
                  style: { width: "0px", height: " 0px", overflow: "hidden", outline: "none" }
                }
              )
            ]
          }
        )
      }
    ),
    T ?? r().document.body
  );
};
J.displayName = "ReoPopup";
export {
  J as default
};
//# sourceMappingURL=ReoPopup.mjs.map
